import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { LoginApiService } from '../../services/api/login-api.service';
import { UsersService } from 'src/app/services/users/users.service';
import { logo } from 'src/app/config/imagenes';
import { Usuario } from 'src/app/models/user-model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserModel } from 'src/app/models/user.model';

export interface listUser {
    selected: any;
    values: listUserValues[]
}
export interface listUserValues {
    label: string,
    value: listUserValue
}

export interface listUserValue {
    id?: any;
    password?: string;
    name?: string
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [UsersService]
})

export class LoginComponent implements OnInit {

    readonly formLogin = new FormGroup({
        user: new FormControl('', [Validators.required, Validators.minLength(3)]),
        password: new FormControl('', [Validators.required]),
    });

    public error: boolean = false;
    public logoUrl: boolean = true;
    public password: string = '';
    public isDoLoginLoading: boolean = false;
    public errorMsg: string = '';
    public logo: string = logo;

    public userList: listUser = {
        selected: null,
        values: [
            { label: '...', value: { id: '' } },
        ]
    };

    public static createNavigation(router: Router) {
        router.navigate(['login']);
    }

    constructor(private router: Router,
        private loginApi: LoginApiService,
        private userServiceLogin: UsersService,
    ) { }

    ngOnInit() {
        this.loginApi.checkCurrentSession()
            .then((exists: Boolean) => {
                if (exists) {
                    DashboardComponent.createNavigation(this.router);
                }
            });
    }

    public setUser(user: listUserValues) {
        this.userList.selected = user;
    }

    public doLogin() {
        if (this.formLogin.invalid) { return; }
        const { user, password } = this.formLogin.value;
        let myuser: any = {
            "nombre": user,
            "password": password
        };

        this.userServiceLogin.loginUsers(myuser).subscribe((resp: Usuario) => {
            if (resp != null) {
                if (resp.role == null) {
                    this.errorMsg = "Contraseña incorrecta!";
                    this.isDoLoginLoading = false;
                    return;
                }

                if (localStorage.getItem('role') !== resp.role) {
                    sessionStorage.setItem('refresh', true.toString());
                } else {
                    sessionStorage.setItem('refresh', false.toString());
                }

                if (resp.role != null && resp.role == "ROLE_ADMIN") {
                    localStorage.setItem("role", "ROLE_ADMIN");
                } else {
                    localStorage.setItem("role", resp.role);
                    localStorage.setItem("documentos", resp.documentos ?? '');
                }

                if (resp.read_only != null) {
                    localStorage.setItem("read_only", (resp.read_only as any) == '1' ? '1' : '0');
                }

                this.errorMsg = "";
                this.isDoLoginLoading = true;

                setTimeout(() => {
                    this.loginApi.doLogin(new UserModel(user ?? '', password ?? ''))
                        .then((isValid: boolean) => {
                            if (isValid) {
                                DashboardComponent.createNavigation(this.router);
                            } else {
                                this.error = true;
                            }
                            this.isDoLoginLoading = false;
                        })
                        .catch(() => {
                            this.error = true;
                            this.isDoLoginLoading = false;
                        });
                }, 700);

            } else {
                this.errorMsg = "Contraseña incorrecta!";
                this.isDoLoginLoading = false;
            }
        }, error => {
            console.log("error", error);
        });
    }
}
